import type { TourStep } from '../types';

export const creatingAccountSteps: TourStep[] = [
  {
    target: '[data-tour="sidebar"]',
    title: 'Welcome to Ashlar',
    content:
      'Congratulations on creating your account! This quick tour will show you what happened during signup and what to do next.',
    placement: 'right',
  },
  {
    target: 'a[href="/dashboard"]',
    title: 'Your Dashboard',
    content:
      'After signing up, you landed here — your central hub. It shows active appraisals, upcoming due dates, and recent activity at a glance.',
    placement: 'right',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="settings-account"]',
    title: 'Check Your Account Details',
    content:
      'Your login email and sign-in method live here. You can link a Google account, add a password, or update your email. Take a look.',
    placement: 'bottom',
    route: '/settings',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="settings-2fa"]',
    title: 'Enable Two-Factor Auth',
    content:
      'We strongly recommend enabling 2FA. It takes 30 seconds to set up and protects your account if your password is ever compromised.',
    placement: 'bottom',
    route: '/settings',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ll do this later',
  },
  {
    target: 'a[href="/business"]',
    title: 'Next: Complete Your Profile',
    content:
      'Head to My Business to add your license, firm details, and bio. This unlocks full platform access and populates your reports automatically.',
    placement: 'right',
    isActionStep: true,
    spotlightClicks: true,
  },
];
